module.exports = __webpack_public_path__ + "static/media/logo856927f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/onboarding/images/logo.svg
// module id = 1550
// module chunks = 0